
















































































































































































































import {Vue, Component, Prop, PropSync} from 'vue-property-decorator';
import {DeliveryCompany, GetClaimsNo, GetDeliveryCompaniesRequest} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import {
  isExchangeClaim,
  isExchangeRequest,
  isExchangeRejectRequest,
  isExchangeProcRequestRefund,
  isExchangeProcBeforeReceive,
  isReturnClaim,
  isReturnRequest,
  isReturnRejectRequest,
  isReturnProcRequestRefund,
  isReturnProcBeforeReceive,
  isCancelExchange
} from '@/components/claim/popup/validations';
import {ClaimStatusType, ClaimType, ReturnWayType} from '@/types/claim';
import {centerWinOptions} from '@/utils/commonUtils';

// // 교환, 반품정보(J)
@Component({
  components: {
    CompSelectBox,
    CompRadioButton
  },
  computed: {
    isCancelExchange,
    isExchangeClaim,
    isExchangeRequest,
    isExchangeRejectRequest,
    isExchangeProcBeforeReceive,
    isExchangeProcRequestRefund,
    isReturnClaim,
    isReturnRequest,
    isReturnProcRequestRefund,
    isReturnRejectRequest,
    isReturnProcBeforeReceive,
    isSellerCollect(){
      return this.returnWayTypeSync === ReturnWayType.SELLER_COLLECT
    },
    disableReturnInfoRow(){
      return (this.isExchangeClaim && !this.isExchangeRequest)
    }
  }
})
export default class ClaimInformation extends Vue{
  @Prop({required: true})
  private readonly claimType!: ClaimType

  @Prop({required: true})
  private readonly claimStatusType!: ClaimStatusType

  @Prop({required: true})
  private readonly claimNoResponseData!: GetClaimsNo

  @Prop({required: true})
  private readonly isModifyMode!: boolean

  @PropSync('invoiceNo')
  private invoiceNoSync!: string

  @PropSync('deliveryCompanyType')
  private deliveryCompanyTypeSync!: string

  @PropSync('returnWayType')
  private returnWayTypeSync!: ReturnWayType

  private returnWayTypeOptions = {
    name: 'returnWayTypeOptions',
    data: [
      {
        id: 'accountDisplayTypesRandom',
        value: 'SELLER_COLLECT',
        dispaly: 'CLAIM_POPUP_SELLER_COLLECT',
      },
      {
        id: 'accountDisplayTypesSequential',
        value: 'BUYER_DIRECT_RETURN',
        dispaly: 'CLAIM_POPUP_BUYER_DIRECT_RETURN',
      },
    ],
  };
  private showExpandData = false
  private deliveryCompanyTypes: DeliveryCompany[] = [];

  created() {
    this.fetchDeliveryCompanies();
  }

  private async fetchDeliveryCompanies(): Promise<void> {
    const request: GetDeliveryCompaniesRequest = {
      params: {
        countryCd: 'KR'
      }
    };
    const { data } = await this.$api.getDeliveryCompanies(request);

    this.deliveryCompanyTypes = data;
  }
  private get expanded() {
    return this.showExpandData ? 'is_expanded' : '';
  }

  private toggleShowExpandData() {
    this.showExpandData = !this.showExpandData
  }

  private onOpenModifyAddressPopup(){
    const { WIDTH, HEIGHT } = { WIDTH: 600, HEIGHT: 500 };
    window.open(
      `/claim/modify/address?claimNo=${this.$route.query.claimNo}`,
      '_blank',
      centerWinOptions(WIDTH, HEIGHT)
    );
  }


  private onlyNumberAndEnglish(e: KeyboardEvent){
    const $taget = e.target as HTMLInputElement;
    $taget.value=$taget.value.replace(/[^0-9a-zA-Z]/g,'');
  }

  private checkOnlyIntegerAndAlphabet(e: KeyboardEvent){
    // Allow:  , escape, enter
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].includes(e.key) ||
      // Allow: Ctrl + A/X/V/C or Command + A/X/V/C
      (e.key === 'Control'|| e.metaKey) ||
      // Allow: home, end, left, right, down, up
      (['Home', 'End', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp'].includes(e.key))) {
      // let it happen, don't do anything
      return;
    }

    //TODO: keyCode는 deprecated 되었음.  타 QA 해결 후 수정
    // 영어 대소문자 허용
    if ((e.keyCode > 64 && e.keyCode < 91) || (e.keyCode > 96 && e.keyCode < 123)) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }
}
